import { memo } from 'react';
import { t } from 'i18next';
import { Stack } from '@mui/system';
import { Divider } from '@mui/material';

import { Accordion } from '@common/components/Accordion';
import { LoadType } from '@/modules/salesWorkspace/components/propertyPanel/layout/components/singularStation/LoadType';
import { LoadHandlingPoiSpec } from '@/modules/salesWorkspace/components/propertyPanel/layout/components/singularStation/LoadHandlingPoiSpec';
import { ConstellationSpec } from '@/modules/salesWorkspace/components/propertyPanel/layout/components/common/ConstellationSpec';
import { VehicleType } from '@/modules/salesWorkspace/components/propertyPanel/layout/components/common/VehicleType';
import { useReadSelectedAreas } from '@/modules/floorplanDesign/hooks';
import { PropertiesLabel } from '@/modules/common/components/PropertiesLabel';

import { CarrierSide } from './singularStation/CarrierSide';
import { AreaDimensions } from './AreaDimensions';
import { LoadHandlingType } from './singularStation/LoadHandlingType';
import { StationSpecProperties } from './singularStation/StationSpecProperties';
import { SingularStationPoiPreferences } from './singularStation/SingularStationPoiPreferences';
import { SingularConnectNeighbors } from './singularStation/SingularConnectNeighbors';

function SingularStationAreaParametersComponent() {
  const { singularStationAreas: selectedSingularStationAreas } = useReadSelectedAreas();

  const selectedSingularStationArea =
    selectedSingularStationAreas.length === 1 ? selectedSingularStationAreas[0] : undefined;

  if (selectedSingularStationAreas.length === 0) return null;

  return (
    <Stack spacing={1} divider={<Divider />}>
      <AreaDimensions />

      <Accordion
        title={t<string>(
          'interface:properties.singular_station_area.title',
          'Singular Station Area',
        )}
        unmountOnExit
        defaultExpanded
        sx={{ px: 2 }}
      >
        <Stack direction='column' spacing={1} pb={2}>
          <LoadHandlingType />
          <Accordion title='Constellation settings' unmountOnExit defaultExpanded>
            <Stack direction='column' spacing={1}>
              <ConstellationSpec />
            </Stack>
          </Accordion>
          <Accordion title='Load carrier settings' unmountOnExit defaultExpanded sx={{ mt: 1 }}>
            <Stack direction='column' spacing={1}>
              <LoadType />
              <CarrierSide />
              <StationSpecProperties selectedSingularStationAreas={selectedSingularStationAreas} />
            </Stack>
          </Accordion>

          <Accordion title='Vehicle settings' unmountOnExit defaultExpanded>
            <Stack direction='column' spacing={1}>
              <LoadHandlingPoiSpec selectedArea={selectedSingularStationArea} />

              {selectedSingularStationArea && (
                <SingularStationPoiPreferences
                  selectedSingularStationArea={selectedSingularStationArea}
                />
              )}

              <PropertiesLabel i18nkey='interface:properties.area.connect_neighbors'>
                <SingularConnectNeighbors />
              </PropertiesLabel>
              <VehicleType />
            </Stack>
          </Accordion>
        </Stack>
      </Accordion>
    </Stack>
  );
}

export const SingularStationAreaParameters = memo(SingularStationAreaParametersComponent);
